<template>
  <!-- Open button -->
  <v-list-item @click.stop="downloadBill">
    <v-icon class="secondary--text">mdi-receipt-text-outline</v-icon>
    <v-list-item-title class="secondary--text">
      Descargar factura
    </v-list-item-title>
  </v-list-item>
</template>

<script>
// Import services
import BillingService from "../../../services/BillingService";

export default {
  props: {
    saleData: {
      type: Object
    }
  },
  data() {
    return {};
  },
  methods: {
    async downloadBill() {
      // Download invoice
      const blob = await BillingService.downloadInvoice(
        this.saleData.billing_info.id
      );

      // Create a link element and trigger a download
      const link = document.createElement("a");
      link.href = window.URL.createObjectURL(blob);
      link.download = `factura-${this.saleData.billing_info.id}.zip`;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    }
  }
};
</script>
